module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kpYzN"))).then(() => parcelRequire('hEqeo'));